import { Card } from '@mui/material';
import './styles.scss';
export const CheckoutLoadingSkeleton = () => {
	return (
		<div className="container checkout-loading-screen p-10 w-100 h-100">
			<Card
				className="h-100 rounded-lg p-15 d-flex flex-column align-items-start"
				style={{ gap: 24 }}
			>
				<div className="skeleton-box w-100"></div>
				<div className="skeleton-box w-100"></div>
				<div className="d-flex w-100" style={{ gap: 24 }}>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
				</div>
				<div className="skeleton-box w-100"></div>

				<div
					className="skeleton-box w-25 mt-6"
					style={{ height: 32 }}
				></div>
				<div className="skeleton-box w-100"></div>
				<div className="d-flex w-100" style={{ gap: 24 }}>
					<div className="skeleton-box" style={{ flex: 1.5 }}></div>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
				</div>
				<div className="skeleton-box w-100"></div>

				<div
					className="skeleton-box w-25 mt-6"
					style={{ height: 32 }}
				></div>
				<div className="d-flex w-100" style={{ gap: 24 }}>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
					<div className="skeleton-box" style={{ flex: 1.5 }}></div>
				</div>
			</Card>
		</div>
	);
};

/**
 * Skeleton do FORMULÁRIO, no formato do que vai aparecer: dados pessoais,
 * endereço e pagamento. Substitui o spinner — que não dizia o que estava por
 * vir e, por ser branco, sumia no cartão do tema claro.
 *
 * Segue o tema (as caixas usam as variáveis do tema e a animação escura), ao
 * contrário da tela cheia acima, que fixa a paleta clara de propósito.
 */
export const CheckoutFormSkeleton = () => (
	<div
		className="checkout-skeleton"
		role="status"
		aria-busy="true"
		aria-label="Carregando o checkout"
	>
		<div className="skeleton-box skeleton-title" />
		<div className="skeleton-box" />
		<div className="checkout-skeleton-row">
			<div className="skeleton-box" style={{ flex: 1.6 }} />
			<div className="skeleton-box" style={{ flex: 1 }} />
		</div>
		<div className="skeleton-box" />

		<div className="skeleton-box skeleton-title mt-4" />
		<div className="checkout-skeleton-row">
			<div className="skeleton-box" style={{ flex: 1 }} />
			<div className="skeleton-box" style={{ flex: 1 }} />
			<div className="skeleton-box" style={{ flex: 1 }} />
		</div>
		<div className="skeleton-box" />

		<div className="skeleton-box skeleton-button mt-4" />
	</div>
);

/** Skeleton do RESUMO da compra: a linha do item e o total. */
export const CheckoutSummarySkeleton = () => (
	<div
		className="checkout-skeleton checkout-skeleton--summary"
		role="status"
		aria-busy="true"
		aria-label="Carregando o resumo da compra"
	>
		<div className="checkout-skeleton-row">
			<div className="skeleton-box skeleton-line" style={{ flex: 2 }} />
			<div className="skeleton-box skeleton-line" style={{ flex: 1 }} />
		</div>
		<div className="checkout-skeleton-row">
			<div className="skeleton-box skeleton-line" style={{ flex: 1 }} />
			<div className="skeleton-box skeleton-total" style={{ flex: 1 }} />
		</div>
	</div>
);
